module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_bg-927afd535e80eb341298affebd19971d.jpg";